import { ArrowRightOutlined } from '@ant-design/icons';
import { type ProcedimentoConTask } from '@framework/api-client/api/backoffice/schemas/procedimentoConTask.ts';
import { DossierStateTag } from '@framework/common-web/schema/dossiers/components/DossierStateTag.tsx';
import { LinkButton } from '@framework/ui/components/button/LinkButton.tsx';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { generatePath } from '@framework/ui/core/router/TypedRoute.tsx';
import { Space } from 'antd';
import clx from 'classnames';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const DossierCardCoverWrapper = styled.div`
  padding: 4px;
`;
const DossierCardCoverLabel = styled.div`
  /* text-transform: uppercase; */
  font-size: 0.9em;
  line-height: 1.3;
`;
const DossierCardCoverText = styled.div`
  font-size: 1.2em;
  line-height: 1.3;
  > .ant-tag {
    margin-inline-end: 0;
  }
`;

const DossierCardElement = styled.div`
  padding: 8px 16px;
  &.is-dossier-page {
    ${DossierCardCoverLabel} {
      font-size: 1em;
    }
    ${DossierCardCoverText} {
      font-size: 1.5em;
      font-weight: bold;
    }
  }
`;
const DossierCardElementWhite = styled(DossierCardElement)`
  background-color: #fff;
  border-radius: ${props => props.theme.borderRadius}px;
`;

export interface DossierCardCoverProps {
  isDossierPage?: boolean;
  procedureDossier?: ProcedimentoConTask;
}

/**
 * ResponsiveCard personalizzata
 */
export function DossierCardCover(props: DossierCardCoverProps) {
  const { procedureDossier, isDossierPage } = props;
  const { t } = useTranslation();

  return (
    <DossierCardCoverWrapper>
      <DossierCardElement
        className={clx({ 'is-dossier-page': props.isDossierPage })}
      >
        <FlexRow
          responsive
          align="flex-start"
          gutter={24}
          right={
            <Space size={16}>
              <div>
                <DossierCardCoverLabel>Numero</DossierCardCoverLabel>
                <DossierCardCoverText>
                  {procedureDossier?.numero ?? '-'}
                </DossierCardCoverText>
              </div>
              <div>
                <DossierCardCoverLabel>Stato</DossierCardCoverLabel>
                <DossierCardCoverText style={{ lineHeight: 1 }}>
                  <DossierStateTag state={procedureDossier?.pratica?.stato} />
                </DossierCardCoverText>
              </div>
              {!isDossierPage && procedureDossier && (
                <div>
                  <LinkButton
                    size="large"
                    to={generatePath('/pratiche/:id', {
                      id: procedureDossier.id!,
                    })}
                  >
                    {t(
                      'dossier-card-cover.dossier-link-button',
                      'Vai alla Pratica',
                    )}
                    {}
                    <ArrowRightOutlined />
                  </LinkButton>
                </div>
              )}
            </Space>
          }
        >
          <DossierCardCoverLabel>Oggetto Pratica</DossierCardCoverLabel>
          <DossierCardCoverText>
            {procedureDossier?.oggetto ?? '-'}
          </DossierCardCoverText>
        </FlexRow>
        {/* {!props.isDossierPage && <VerticalSpace size={4} />} */}
      </DossierCardElement>
      {/* {!props.isDossierPage && (
        <DossierCardElementWhite>
          <NakedCollapse
            removeBottomPadding
            items={[
              {
                key: 'detail',
                label: <Space>Dettagli Pratica</Space>,
                children: <DossierDescriptions compact />,
              },
            ]}
          />
        </DossierCardElementWhite>
      )} */}
    </DossierCardCoverWrapper>
  );
}
